import PropTypes from "prop-types";
import cn from "classnames";
import scrollbarSize from "dom-helpers/scrollbarSize";
import React from "react";
import { connect } from "react-redux";
import dates from "react-big-calendar/lib/utils/dates";
import _ from 'lodash';
import notify from "react-big-calendar/lib/utils/helpers";

const Header = ({ label }) => {
  return <span>{label}</span>;
};

class TimeGridTotal extends React.Component {
  handleHeaderClick = (date, view, e) => {
    e.preventDefault();
    notify(this.props.onDrillDown, [date, view]);
  };

  renderHeaderCells() {
    let { date, events, getNow, employees } = this.props;

    const eventsList = _.map(events, (obj, key) => {
      return obj;
    })

    const today = getNow();

    const min = dates.startOf(date, "day");
    const max = dates.endOf(date, "day");

    return employees.map((emp, i) => {
      let drilldownView = false;
      let totalWorkingHours = 0.0;

      eventsList
        .filter(
          event =>
            event.EmployeeID == emp.EmployeeAutoID &&
            (dates.diff(event.start, date, "day") == 0 ||
              dates.diff(event.end, date, "day") == 0)
        )
        .map(event => {
          let startTime = dates.max(event.start, min);
          let endTime = dates.min(event.end, max);
          const duration = dates.diff(startTime, endTime, "seconds") / 3600;
          totalWorkingHours = totalWorkingHours + duration;
        });

        totalWorkingHours = totalWorkingHours.toFixed(2);
      let cellStyle = totalWorkingHours > 0 ? "spanstyle" : "spanstyle-default";

      return (
        <div key={i} className={cn("rbc-header", "rbc-total-cell")}>
          <div>
            <span className={cn("rbc-label", "totalstyle", cellStyle)}>
              {totalWorkingHours} H
            </span>
          </div>
        </div>
      );
    });
  }

  render() {
    let {
      width,
      rtl,
      employees,
      range,
      events,
      getNow,
      accessors,
      selectable,
      components,
      getters,
      scrollRef,
      localizer,
      isOverflowing
    } = this.props;

    let style = {};
    if (isOverflowing) {
      style[rtl ? "marginLeft" : "marginRight"] = `11px`;
    }

    const groupedEvents = [];

    return (
      <div
        style={style}
        ref={scrollRef}
        className={cn("rbc-time-header", isOverflowing && "rbc-overflowing")}
      >
        <div
          className="rbc-label rbc-time-header-gutter"
          style={{ width, minWidth: width, maxWidth: width }}
        />
        <div className="rbc-time-header-content">
          <div className={`rbc-row rbc-time-header-cell`}>
            {this.renderHeaderCells()}

            <div
              className={cn("rbc-header", "rbc-day-slot", "rbc-time-column")}
            >
              <div className="rbc-time-slot">
                <span className={cn("rbc-label", "totalstyle")}> - </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.roster.displayWorkEvents
  };
}

export default connect(mapStateToProps)(TimeGridTotal);
